@if (imagesList.length) {
<div class="image-viewer-wrapper mobile-image-carousel">
  <!-- Preview Image -->
  <webstore-pinch-zoom
    [imageSrcInput]="images[previewIndex]?.image || ''"
    (moveToNextSlide$)="next()"
    (moveToPreviousSlide$)="previous()"
  ></webstore-pinch-zoom>

  <!-- Previous -->
  <button
    type="button"
    class="prev-btn"
    [class.btn-disabled]="previewIndex === 0"
    (click)="previous()"
  >
    <img [src]="IMAGE_URLS.leftNavIcon" class="navigation-icon" />
  </button>

  <!-- Next -->
  <button
    type="button"
    class="next-btn"
    [class.btn-disabled]="previewIndex === (imagesList.length || 0) - 1"
    (click)="next()"
  >
    <img [src]="IMAGE_URLS.rightNavIcon" class="navigation-icon" />
  </button>
</div>
} @else {
<!-- for no Preview Image state -->
<div class="image-viewer-wrapper">
  <div class="image-container">
    <img [src]="IMAGE_URLS.noImagePlaceholder" class="display-image" />
  </div>
</div>
}
